import { mapActions, mapState } from 'vuex'
import formButton from '@/components/common/form-button/form-button.vue'
import router from '@/router'
import { formatDate } from '@/helpers/date'

export default {
  components: {
    formButton
  },
  data() {
    return {
      columns: ['id', 'name', 'created_at', 'updated_at', 'edit']
    }
  },
  computed: {
    ...mapState('workflow', ['workflowList']),
    options: function () {
      return {
        filterable: false,
        headings: {
          edit: ' '
        },
        perPage: 6,
        orderBy: {
          column: 'name'
        },
        requestFunction: function (data) {
          return this.getWorkflowsList({ offset: (data.page - 1) * this.options.perPage, limit: this.options.perPage })
        }.bind(this),
        responseAdapter: function (resp) {
          var data = this.getResponseData(resp)
          return {
            data: data.data,
            count: data.total
          }
        }
      }
    }
  },
  methods: {
    ...mapActions('workflow', ['getWorkflowsList', 'setCurrentlyEditedWorkflow']),
    toggleEditRow: function (workflowId) {
      this.setCurrentlyEditedWorkflow(this.workflowList.data.filter((workflow) => workflow.id === workflowId)[0])
      router.push({ name: 'workflow-edit' })
    },
    formatDate
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/workflows/workflows-list/workflows-list.js